/**
 * Simple function to handle all scrolling in the application
 * @param id - The ID of the section to scroll to
 * @param isFromOtherPage - Whether this scroll is triggered from another page via hash
 */
export const scrollToSection = (id: string, isFromOtherPage = false) => {
  // If coming from hash or other page, add a small delay to ensure DOM is ready
  if (isFromOtherPage) {
    setTimeout(() => scrollToElementById(id), 500);
  } else {
    scrollToElementById(id);
  }
};

/**
 * Helper function to do the actual scrolling
 * @param id - The ID of the element to scroll to
 */
const scrollToElementById = (id: string) => {
  const element = document.getElementById(id);
  if (!element) return;
  
  // Get the navbar height dynamically if possible, or use a fixed value
  const navbar = document.querySelector('header');
  const navbarHeight = navbar ? navbar.getBoundingClientRect().height : 80;
  
  // Simple scroll that only accounts for the navbar height
  const elementPosition = element.getBoundingClientRect().top;
  const offsetPosition = elementPosition + window.pageYOffset - navbarHeight;
  
  // Perform the scroll
  window.scrollTo({
    top: offsetPosition,
    behavior: 'smooth'
  });
};
